import React from "react";
import ReactDOM from "react-dom/client";

import "simplebar/src/simplebar.css";

import themes from "devextreme/ui/themes";

import * as EzhouCommon from "@ezhou/common";
import { registerGlobalDateToJsonToIgnoreTimeAndTimeZone } from "@ezhou/common-utils";
import { LoggerService } from "@ezhou/common-logging-typescript-logging";
import { AppConfig, AppContext } from "@ezhou/core";
import { loadEzhouApp } from "@ezhou/app_mantis_1_1";

import { App } from "./App";

registerGlobalDateToJsonToIgnoreTimeAndTimeZone();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

loadEzhouApp(
  [
    `${process.env.PUBLIC_URL}/assets/app.config.json`,
    `${process.env.PUBLIC_URL}/assets/rolePermissions.json`,
    `${process.env.PUBLIC_URL}/assets/logging.json`,
    `${process.env.PUBLIC_URL}/assets/authentication.json`,
    `${process.env.PUBLIC_URL}/assets/httpClients.json`,
    `${process.env.PUBLIC_URL}/customizedAssets/authentication.json`,
    `${process.env.PUBLIC_URL}/customizedAssets/httpClients.json`,
    `${process.env.PUBLIC_URL}/customizedAssets/others.json`,
  ],
  (data) => {
    const appConfig = data.getSection<AppConfig>("appConfig");
    const logService: EzhouCommon.ILoggerService = new LoggerService();
    const appContext = new AppContext();

    themes.initialized(() =>
      root.render(
        <App
          title="Art Digit Accounting"
          config={data}
          appConfig={appConfig}
          logService={logService}
          appContext={appContext}
        />,
      ),
    );
  },
);
